import { __rest } from '../../../../../../_virtual/_tslib.js';
import { useGoogleTagManager } from '@helix/useGoogleTagManager';
import { useWindowWidth } from '@lwt-helix/useWindowWidth';
import React, { useImperativeHandle } from 'react';
import { GlobalNavStyles, StyledNavbar } from './Navbar.styles.js';
import { NavbarProvider } from './NavbarContext.js';
import NavbarExpandButton from './NavbarExpandButton.js';
import NavbarLogo from './NavbarLogo.js';
import NavbarMobileMenu from './NavbarMobileMenu.js';

const Navbar = React.forwardRef((_a, ref) => {
    var { applicationName, logoUrl = '/', children, isDark = false, fixed = false, className, dataLwtId, hideLogo = false, hideLogoOnMobile = false, variant = 'large', logoLinkWrapper, onExpandIconClick, expandIconActive, customMobileMenu, mobileMenuOpen = false, onMobileMenuToggle, applicationCode, environment = 'dev', localStorageTokenKey = 'lwaToken', token } = _a, rest = __rest(_a, ["applicationName", "logoUrl", "children", "isDark", "fixed", "className", "dataLwtId", "hideLogo", "hideLogoOnMobile", "variant", "logoLinkWrapper", "onExpandIconClick", "expandIconActive", "customMobileMenu", "mobileMenuOpen", "onMobileMenuToggle", "applicationCode", "environment", "localStorageTokenKey", "token"]);
    const { windowWidth } = useWindowWidth();
    const { dataLayer, setDataLayer } = useGoogleTagManager({
        gtmContainerId: 'GTM-TW6R356J',
        applicationCode,
        environment,
        localStorageTokenKey,
        userToken: token
    });
    // use imperative handle to pass the dataLayer to the parent component and the setDataLayer function
    useImperativeHandle(ref, () => {
        return {
            dataLayer,
            setDataLayer
        };
    }, [dataLayer, setDataLayer]);
    let reactChildren = children;
    const ReactChildrenArrayFirst = React.Children.toArray(children)[0];
    // if the first child is a fragment check its children
    if (React.Children.count(children) === 1 && ReactChildrenArrayFirst.type === React.Fragment) {
        reactChildren = ReactChildrenArrayFirst.props.children;
    }
    const appSwitcher = React.Children.toArray(reactChildren).filter((child) => (child && child.type && child.type.displayName && child.type.displayName === 'ApplicationSwitcher') ||
        (child &&
            child.props &&
            child.props.originalType &&
            child.props.originalType.displayName === 'ApplicationSwitcher'))[0];
    const hasBothNavbarBodyAndNavbarNavigationBar = () => {
        const navbarBody = React.Children.toArray(reactChildren).filter((child) => (child && child.type && child.type.displayName && child.type.displayName === 'NavbarBody') ||
            (child &&
                child.props &&
                child.props.originalType &&
                child.props.originalType.displayName === 'NavbarBody'))[0];
        const navbarNavigationBar = React.Children.toArray(reactChildren).filter((child) => (child &&
            child.type &&
            child.type.displayName &&
            child.type.displayName === 'NavbarNavigationBar') ||
            (child &&
                child.props &&
                child.props.originalType &&
                child.props.originalType.displayName === 'NavbarNavigationBar'))[0];
        return navbarBody && navbarNavigationBar;
    };
    return (React.createElement(NavbarProvider, { hideLogo: hideLogo || (hideLogoOnMobile && windowWidth < 576), logoUrl: logoUrl, isDark: isDark, isMobileMenuOpen: mobileMenuOpen, customMobileMenu: customMobileMenu, onMobileMenuToggle: (isOpen) => onMobileMenuToggle && onMobileMenuToggle(isOpen) },
        React.createElement(React.Fragment, null,
            React.createElement(GlobalNavStyles, null),
            React.createElement(StyledNavbar, Object.assign({ className: `helix-unified-nav__nav ${className ? className : ''}`, "$fixed": fixed, "$isDark": isDark, "data-lwt-id": dataLwtId, "$reducePaddingLeft": hasBothNavbarBodyAndNavbarNavigationBar(), "$hasExpandIcon": onExpandIconClick ? true : false, "$variant": variant }, rest),
                onExpandIconClick && windowWidth > 576 && (React.createElement(NavbarExpandButton, { expandIconActive: expandIconActive, onExpandIconClick: onExpandIconClick })),
                React.createElement(NavbarLogo, { appSwitcher: appSwitcher, linkWrapper: logoLinkWrapper, applicationName: applicationName }),
                React.Children.map(reactChildren, (child) => {
                    if (child &&
                        child.type &&
                        child.type.displayName &&
                        child.type.displayName !== 'ApplicationSwitcher') {
                        return child;
                    }
                }),
                windowWidth < 576 && React.createElement(NavbarMobileMenu, null)))));
});
Navbar.displayName = 'Navbar';

export { Navbar as default };
//# sourceMappingURL=Navbar.js.map
